import * as React from "react";
const IconPageBreak = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M46.8 1.8H17.2c-2.9 0-5.3 2.4-5.3 5.3v14.4c0 2.9 2.4 5.3 5.3 5.3h29.7c2.9 0 5.3-2.4 5.3-5.3V7c-.1-2.9-2.5-5.2-5.4-5.2m.8 19.6c0 .4-.3.8-.8.8H17.2c-.4 0-.8-.3-.8-.8V7c0-.4.3-.8.8-.8h29.7c.4 0 .8.3.8.8v14.4zM46.8 37.4H17.2c-2.9 0-5.3 2.4-5.3 5.3V57c0 2.9 2.4 5.3 5.3 5.3h29.7c2.9 0 5.3-2.4 5.3-5.3V42.6c-.1-2.9-2.5-5.2-5.4-5.2m.8 19.6c0 .4-.3.8-.8.8H17.2c-.4 0-.8-.3-.8-.8V42.6c0-.4.3-.8.8-.8h29.7c.4 0 .8.3.8.8V57zM21.8 34.3c1.2 0 2.3-1 2.3-2.3 0-1.2-1-2.3-2.3-2.3h-5.1c-1.2 0-2.3 1-2.3 2.3 0 1.2 1 2.3 2.3 2.3zM34.5 34.3c1.2 0 2.3-1 2.3-2.3 0-1.2-1-2.3-2.3-2.3h-5.1c-1.2 0-2.3 1-2.3 2.3 0 1.2 1 2.3 2.3 2.3zM47.3 34.3c1.2 0 2.3-1 2.3-2.3 0-1.2-1-2.3-2.3-2.3h-5.1c-1.2 0-2.3 1-2.3 2.3 0 1.2 1 2.3 2.3 2.3z" />
  </svg>
);
export default IconPageBreak;
